import './Admissions_consultant_price.scss';

const priceData = [
  { label: "1개월ㅣ3회", price: "550,000원" },
  { label: "1개월ㅣ3회", price: "550,000원" },
  { label: "1개월ㅣ5~6회", price: "990,000원" },
  { label: "1개월ㅣ3~6회", price: "660,000원" },
  { label: "6개월ㅣ수시", price: "2,200,000원" },
];

const Admissions_consultant_price = () => {
  return (
    <div className='Admissions_consultant_price'>
      <table className="consulting-fee-table-vertical">
        <thead>
          <tr>
            <th>컨설팅 기간</th>
            <th>비용 구분</th>
          </tr>
        </thead>
        <tbody>
          {priceData.map((row, idx) => (
            <tr key={idx}>
              <td>{row.label}</td>
              <td>{row.price}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Admissions_consultant_price;